<template>
  <div>
    <basic-container>
      <!-- //^ ^--------------搜索栏配置-------------^ ^ -->
      <div class="search-contain">
        <div class="media-capital-search-left">
          <el-input clearable v-model="searchParams.search" placeholder="媒资方名称"></el-input>
        </div>
        <div class="search-right">
          <el-button style="margin-left: 20px;" v-auth="'MEDIA_CAPITAL_MANAGE_SEARCH'" type="primary" size="small"
            @click="search">搜索</el-button>
          <el-button v-auth="'MEDIA_CAPITAL_MANAGE_ADD'" type="primary" size="small" @click="handleAdd">新增</el-button>
        </div>
      </div>
      <br />
      <!-- //^ ^--------------表格配置-------------^ ^ -->
      <el-table :data="tableData" border stripe>
        <el-table-column label="媒资方ID" prop="id"></el-table-column>
        <el-table-column label="媒资方名称" prop="name"></el-table-column>
        <el-table-column label="合作状态" prop="status">
          <template slot-scope="scope">
            {{ scope.row.statusLabel }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="descr" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" prop="addTime"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button v-auth="'MEDIA_CAPITAL_MANAGE_EDIT'" type="text" size="small"
              @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-auth="'MEDIA_CAPITAL_MANAGE_DEL'" type="text" size="small"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <ElementPagination style="margin-bottom: 20px;" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </basic-container>
    <!-- //^ ^--------------新增/编辑的对话框-------------^ ^ -->
    <el-dialog :title="isEdit ? '编辑资源方' : '新增资源方'" append-to-body :visible.sync="dialogVisible" width="50%"
      @closed="closeDialog">
      <el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px">
        <el-form-item prop="name" label="媒资方名称">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 99 }" style="width: 80%;" maxlength="99"
            show-word-limit v-model="addForm.name" placeholder="请输入媒资方名称"></el-input>
        </el-form-item>
        <el-form-item label="媒资方描述">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 99 }" style="width: 80%;" maxlength="99"
            show-word-limit v-model="addForm.tips" placeholder="媒资方描述"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-image v-if="addForm.icon" style="width: 200px;" :src="addForm.icon" fit="scale-down"></el-image>
          <el-upload :before-upload="checkUpload" :http-request="upload" listType="picture-img" :show-file-list="false">
            <el-button size="small" type="primary">上传图片</el-button>
          </el-upload>
        </el-form-item>
        <!-- 按钮文案  - 非必填、单行文本输入，99 字符限制-->
        <el-form-item label="按钮文案">
          <el-input style="width: 80%;" maxlength="99" show-word-limit v-model="addForm.buyTips"
            placeholder="按钮文案"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="合作状态">
          <el-select clearable v-model="addForm.status" placeholder="请选择">
            <el-option label="合作中" value="1"></el-option>
            <el-option label="终止" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input style="width: 80%;" v-model="addForm.descr" placeholder="请输入备注"></el-input>
          <!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 99 }" width="50%" maxlength="99" show-word-limit
            v-model="addForm.descr" placeholder="请输入备注"></el-input> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Save">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import {
  getList,
  add,
  edit,
  del
} from "@/api/mediaManage/mediaCapitalManage.js";
export default {
  name: "WebOpenPlatformIndex",
  components: {
    ElementPagination
  },

  data() {
    return {
      /** 是否为编辑 */
      isEdit: false,
      /** 新增/编辑表单内的数据 */
      addForm: {
        name: "",
        tips: "",
        icon: "",
        status: "",
        descr: "",
        buyTips: ""
      },
      /** 新增/编辑对话框的显隐 */
      dialogVisible: false,
      /** 搜索的参数 */
      searchParams: {
        search: "",
        current: 1,
        size: 10,
        total: 50
      },
      /** 表格里的数据 */
      tableData: [],
      /** 表单验证规则 */
      rules: {
        name: [
          { required: true, message: "请输入媒资方名称", trigger: "blur" },
          { min: 1, max: 99, message: "长度在 1 到 99 个字符", trigger: "blur" }
        ],
        status: [
          { required: true, message: "请选择合作状态", trigger: "change" }
        ],
        descr: [
          { min: 1, max: 99, message: "长度在 1 到 99 个字符", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // //^ ^--------------新增/编辑对话框内的事件-------------^ ^
    /** 上传图片校验 */
    checkUpload(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error("不能上传超过5M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      const file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.addForm.icon = result.link;
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 确认保存 */
    Save() {
      console.log("新增/编辑的表单数据", this.addForm);
      /** 进行表单规则验证 */
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          /** 验证通过 */
          /** 判断是新增还是编辑 */
          if (this.isEdit) {
            /** 编辑 */
            /** 调用接口 */
            const { data } = await edit(this.addForm);
            console.log("编辑接口的响应", data);
            /** 如果成功 */
            if (data.code === 200) {
              /** 提示成功 */
              Message.success("编辑成功");
            }
          } else {
            /** 调用新增接口 */
            const { data } = await add(this.addForm);
            console.log("新增接口的响应", data);
            /** 如果成功 */
            if (data.code === 200) {
              /** 提示成功 */
              Message.success("新增成功");
            }
          }

          /** 关闭对话框 */
          this.dialogVisible = false;
          /** 清理表单数据 */
          this.addForm = {
            name: "",
            status: "",
            descr: ""
          };
          /** 清除表单验证规则 */
          this.$nextTick(() => {
            this.$refs.addForm.clearValidate();
          });
          /** 刷新列表 */
          this.getList();
        } else {
          /** 验证不通过 */
          Message.error("请检查表单数据是否填写正确");
          return false;
        }
      });
    },
    //^ ^------------/** 搜索栏相关的事件 */---------------^ ^
    /** 新增按钮 */
    handleAdd() {
      /** 清理表单验证规则 */
      /** 打开对话框 */
      this.dialogVisible = true;
    },
    /** 关闭对话框的事件 */
    closeDialog() {
      /** 清理表单数据 */
      this.addForm = {
        name: "",
        status: "",
        descr: ""
      };
      /** 清除表单验证规则 */
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
      });
      this.isEdit = false;
    },
    //^ ^--------------表格内的事件-------------^ ^
    /** 编辑按钮 */
    handleEdit(row) {
      console.log("编辑的数据", row);
      this.isEdit = true;
      this.dialogVisible = true;
      this.addForm = {
        id: row.id,
        name: row.name,
        tips: row.tips,
        icon: row.icon,
        status: String(row.status),
        descr: row.descr,
        buyTips: row.buyTips
      };
    },
    /** 删除按钮 */
    handleDelete(row) {
      console.log("删除的数据id", row.id);
      /** 二次询问 */
      this.$confirm("此操作将永久删除该媒资方, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        /** 调用删除接口 */
        const { data } = await del(row.id);
        console.log("删除接口的响应", data);
        /** 如果成功 */
        if (data.code === 200) {
          /** 提示成功 */
          Message.success("删除成功");
          /** 刷新列表 */
          this.getList();
        }
      });
    },
    //^ ^--------------分页相关 start-------------^ ^
    /** 获取分页列表 */
    async getList() {

      const { data } = await getList(this.searchParams);
      console.log("获取分页数据的响应", data);
      this.searchParams.total = data.data.total;
      /** 处理数据 */
      const list = data.data.records;
      list.forEach(item => {
        item.statusLabel = item.status === 1 ? "合作中" : "终止";
      });
      /** 赋值 */
      this.tableData = list;
    },
    /** 搜索事件 */
    async search() {
      this.searchParams.current = 1
      await this.getList();
      /** 提示用户 */
      Message.success("搜索成功");
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    }
  }
};
</script>

<style lang="scss" >
.el-tooltip__popper {
  max-width: 80% !important;
}

.search-contain {
  display: flex;
  // justify-content: space-between;
  align-items: center;
}

.media-capital-search-left {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}
</style>
